@if (loading()) {
  <app-cab-loading height="250px" />
} @else {
  <form [formGroup]="form">
    <div class="modal-body mt-4">
      <app-cab-tab>
        <div id="first">
          <div>
            <app-cab-input
              [controlName]="form.get('name_uz')"
              class="w-100"
              label="SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.MODAL.NAME"
              type="text"
            />
            <app-cab-input
              [controlName]="form.get('shortName_uz')"
              class="w-100"
              label="SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.MODAL.SHORT_NAME"
              type="text"
            />
          </div>
        </div>
        <div id="second">
          <div>
            <app-cab-input
              [controlName]="form.get('name_crl')"
              class="w-100"
              label="SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.MODAL.NAME"
              type="text"
            />
            <app-cab-input
              [controlName]="form.get('shortName_crl')"
              class="w-100"
              label="SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.MODAL.SHORT_NAME"
              type="text"
            />
          </div>
        </div>
        <div id="third">
          <div>
            <app-cab-input
              [controlName]="form.get('name_ru')"
              class="w-100"
              label="SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.MODAL.NAME"
              type="text"
            />
            <app-cab-input
              [controlName]="form.get('shortName_ru')"
              class="w-100"
              label="SPRAVOCHNIK.STATUS_TYPES.OWNER_SHIP_TYPES.MODAL.SHORT_NAME"
              type="text"
            />
          </div>
        </div>
      </app-cab-tab>
    </div>
    <div class="d-flex justify-content-sm-end gap-2 modal-footer">
      <app-cab-button
        (btnClick)="onSubmit()"
        [disabled]="form.invalid || isPending()"
        [isPending]="isPending()"
        label="BUTTON.SAVE"
        styleType="success"
      />

      <app-cab-button
        (btnClick)="onCancel()"
        label="BUTTON.CANCEL"
        styleType="light"
      />
    </div>
  </form>
}
